<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <h4>Basis</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div *ngIf="client">
        <div class="row" style="margin-top: 35px;">
          <div class="col-sm-4" *ngFor="let p of imageProperties">
            <mat-card appearance="outlined" class="example-card">
              <mat-card-title> {{ p.showValue }}</mat-card-title>
              <mat-card-subtitle> {{ p.hint }}</mat-card-subtitle>
              <mat-card-content>
                <div>
                  <img [src]="p.value" *ngIf="p.value" style="height: 50px; margin: 10px 0;">
                  <div class="caption">
                  </div>
                </div>
              </mat-card-content>
              <mat-card-actions>
                <button mat-button (click)="openImageGallery(p)" color="primary"> Anderes Bild auswählen</button>
                <button mat-button (click)="saveImage(p)" [disabled]="!p.hasChanged" color="primary">Speichern</button>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <mat-card appearance="outlined" class="example-card">
              <mat-card-title> Name</mat-card-title>
              <mat-card-subtitle> Name des Clients bspw. GATES IT GmbH </mat-card-subtitle>
              <mat-card-content>
                <div>
                  <mat-form-field>
                    <input matInput [(ngModel)]="client.name" (input)="basicDataHasChanged = true;">
                  </mat-form-field>
                </div>

              </mat-card-content>
              <mat-card-actions>
                <button mat-button (click)="saveBasicData()" color="primary"
                  [disabled]="!basicDataHasChanged">Speichern</button>
              </mat-card-actions>
            </mat-card>
          </div>


          <div class="col-sm-6">
            <mat-card appearance="outlined" class="example-card">
              <mat-card-title> Unternehmens-Webseite</mat-card-title>
              <mat-card-subtitle> Unternehmens-Webseite des Clients bspw. https://gates-it.de </mat-card-subtitle>
              <mat-card-content>
                <div>
                  <mat-form-field>
                    <input matInput [(ngModel)]="client.website" (input)="basicDataHasChanged = true;">
                  </mat-form-field>
                </div>

              </mat-card-content>
              <mat-card-actions>
                <button mat-button (click)="saveBasicData()" color="primary"
                  [disabled]="!basicDataHasChanged">Speichern</button>

              </mat-card-actions>
            </mat-card>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <mat-card appearance="outlined" class="example-card">
              <mat-card-title> Adresse</mat-card-title>
              <mat-card-subtitle> Adresse des Clients </mat-card-subtitle>
              <mat-card-content>
                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="25px" fxLayout.lt-md="column">
                  <mat-form-field>
                    <mat-label>Straße:</mat-label>
                    <input matInput [(ngModel)]="address.street" (input)="addressHasChanged = true;">
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>PLZ:</mat-label>
                    <input matInput [(ngModel)]="address.postcode" (input)="addressHasChanged = true;">
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Ort:</mat-label>
                    <input matInput [(ngModel)]="address.city" (input)="addressHasChanged = true;">
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Breitengrad:</mat-label>
                    <input matInput [(ngModel)]="address?.location.lat" (input)="addressHasChanged = true;">
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Längengrad:</mat-label>
                    <input matInput [(ngModel)]="address?.location.lng" (input)="addressHasChanged = true;">
                  </mat-form-field>
                  <!-- <button *ngIf="addressHasChanged" mat-stroked-button color="primary" (click)="saveAddress()">
                          <mat-icon>save</mat-icon>
                          Speichern
                        </button> -->
                </div>
              </mat-card-content>
              <mat-card-actions>
                <button mat-button (click)="saveBasicData()" color="primary"
                  [disabled]="!addressHasChanged">Speichern</button>
                <button mat-button color="primary" (click)="getCoordinates()">
                  Koordinaten ermitteln
                </button>
              </mat-card-actions>
            </mat-card>
          </div>
          <div class="col-sm-6">
            <mat-card appearance="outlined" class="example-card">
              <mat-card-title> Öffnungszeiten</mat-card-title>
              <mat-card-subtitle> Öffnungszeiten des Clients </mat-card-subtitle>
              <mat-card-content>
                <div class="row actionRow" *ngFor="let hour of officeHours; let i = index">
                  <div class="col-lg-8">
                    <mat-form-field>
                      <input matInput [(ngModel)]="hour.value" (input)="officeHours[i].hasChanged = true;">
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <button mat-button color="warn" (click)="removeHour(i)" fxFlex="40%">
                      Entfernen
                    </button>
                  </div>
                  <div class="col-lg-2">
                    <button mat-button color="primary" (click)="saveOfficeHours()" fxFlex="40%"
                      [disabled]="!officeHours[i].hasChanged">
                      Speichern
                    </button>
                  </div>
                </div>
              </mat-card-content>
              <mat-card-actions>
                <button mat-button color="primary" (click)="addOfficeHourRow()">
                  Hinzufügen
                </button>
              </mat-card-actions>
            </mat-card>
          </div>

        </div>

        <div class="row marginBottom2Rem">
          <div class="col-lg-12">
            <mat-card appearance="outlined" class="example-card">
              <mat-card-title>Aktueller Hinweis</mat-card-title>
              <mat-card-subtitle>Hinweis wird einmal pro Tag als Modal gezeigt, wenn gesetzt.</mat-card-subtitle>
              <mat-card-content> 
                <ckeditor [editor]="Editor" [config]="config" style="display:inline-block;width: 100%;min-height: 350px;height: 450px;"  [(ngModel)]="actual_hint"
                (ngModelChange)="this.hintchanged = true;" ></ckeditor> 
              </mat-card-content>
              <mat-card-actions>
                <button mat-button color="primary" (click)="editActualHint()" [disabled]="!hintchanged">
                  Speichern
                </button>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>


        <div class="row">
          <div class="col-lg-12">
            <mat-card appearance="outlined" class="example-card">
              <mat-card-title>Layout Einstellungen</mat-card-title>
              <mat-card-content>
                <div class="row">
                  <div class="col-lg-6">
                    <mat-form-field style="margin-bottom: 20px;">
                      <mat-label>Schriftart:</mat-label>
                      <input matInput [(ngModel)]="layoutData.MAIN_FONT"  (input)="this.layoutChanged = true">
                      <mat-hint>gültiges Format: ("Helvetica Neue",Helvetica,Arial,sans-serif), leeres Feld: "Thesis"
                      </mat-hint>
                    </mat-form-field>
                  </div>
                    <div class="col-lg-6">
                      <mat-form-field style="margin-bottom: 20px;">
                        <mat-label>Aktionsbannerschriftfarbe:</mat-label>
                        <input matInput [(ngModel)]="layoutData.CAROUSEL_FONT_COLOR"  (input)="this.layoutChanged = true">
                        <mat-hint>Schriftfarbe im Aktionsbanner, gültiges Format: "#123456", leeres Feld = weiß
                        </mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
          

                <div class="row">
                  <div class="col-lg-6">
                    <mat-form-field style="margin-bottom: 20px;">
                      <mat-label>Aktionsbannerfarbe:</mat-label>
                      <input matInput [(ngModel)]="layoutData.CAROUSEL_COLOR"  (input)="this.layoutChanged = true">
                      <mat-hint>Hintergrundfarbe des Aktionsbanners, gültiges Format: "#123456", leeres Feld =
                        Primärfarbe
                      </mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field style="margin-bottom: 20px;">
                      <mat-label>Sekundärfarbe:</mat-label>
                      <input matInput [(ngModel)]="layoutData.MAIN_COLOR"  (input)="this.layoutChanged = true">
                      <mat-hint>Farbe für Header: "#123456"</mat-hint>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <mat-form-field style="margin-bottom: 20px;">
                      <mat-label>Primärfarbe:</mat-label>
                      <input matInput [(ngModel)]="layoutData.MAIN_COLOR" (input)="this.layoutChanged = true">
                      <mat-hint>Farbe für Buttons und Links, gültiges Format: "#123456"</mat-hint>
                    </mat-form-field>
                  </div>
                </div>


              </mat-card-content>
              <mat-card-actions>
                <button mat-button color="primary" [disabled]="!layoutChanged" (click)="saveLayoutData()">
                  Speichern
                </button>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>



      </div>
    </div>
  </div>
</div>